type IconProps = {
  width?: number;
  height?: number;
};

const ArrowRight = ({ width = 36, height = 36 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M41.6665 25L43.1396 23.5269L44.6128 25L43.1396 26.4731L41.6665 25ZM10.4165 27.0833C9.26591 27.0833 8.33317 26.1506 8.33317 25C8.33317 23.8494 9.26591 22.9167 10.4165 22.9167V25V27.0833ZM29.1665 12.5L30.6396 11.0269L43.1396 23.5269L41.6665 25L40.1934 26.4731L27.6934 13.9731L29.1665 12.5ZM41.6665 25L43.1396 26.4731L30.6396 38.9731L29.1665 37.5L27.6934 36.0269L40.1934 23.5269L41.6665 25ZM41.6665 25V27.0833H10.4165V25V22.9167H41.6665V25Z" fill="#241802" />
    </svg>
  );
};

export default ArrowRight;
